<template>
  <reason-rejection
    :rejectionType="'Poda'"
    @showHideLoading="showHideLoading"
  />
</template>
<script>
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import ReasonRejection from 'src/views/Pages/Dashboard/Nursery/ReasonRejection/ReasonRejection.vue';

export default {
  components: {
    [ReasonRejection.name]: ReasonRejection,
  },
  mixins: [MixinMenu, MixinLoading],
};
</script>
